export default __webpack_public_path__ + "static/media/profilePhoto.f9a70736.jpg";